// Language & Translations
export const DEFAULT_LOCALE = process.env.VUE_APP_I18N_LOCALE;
export const APP_LANGUAGES = ['es', 'en'];
export const MODEL_INSTANCES_LANGUAGES = ['es', 'en'];
